import React, { useState, useEffect } from 'react';
import { useAuth } from '../../AuthContext';
import { LuCopy, LuCheck } from 'react-icons/lu';

export default function ClientReferralsPage() {
  const { user, token } = useAuth();
  
  const [isCopied, setIsCopied] = useState({ direct: false, telegram: false });
  const [referralData, setReferralData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReferralInfo = async () => {
      if (!token) return;
      
      setLoading(true);
      try {
        const response = await fetch('/api/client/referrals/info', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setReferralData(data);
        }
      } catch (e) {
        console.error('Ошибка загрузки реферальной информации:', e);
      } finally {
        setLoading(false);
      }
    };
    
    if (user && token) {
      fetchReferralInfo();
    }
  }, [user, token]);

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    setIsCopied({ ...isCopied, [type]: true });
    setTimeout(() => {
      setIsCopied({ ...isCopied, [type]: false });
    }, 2000);
  };

  const handleShareTelegram = () => {
    if (referralData?.referral_link_telegram) {
      window.open(referralData.referral_link_telegram, '_blank');
    }
  };

  if (!user || loading) {
    return (
      <main className="client-page-content">
        <div className="loading-mini">Загрузка...</div>
      </main>
    );
  }

  if (!referralData) {
    return (
      <main className="client-page-content">
        <div className="empty-state">Ошибка загрузки данных</div>
      </main>
    );
  }

  const info = referralData.referral_info || {};

  return (
    <main className="client-page-content">
      <section className="referral-section">
        {/* Информация о системе */}
        {info.type === 'DAYS' ? (
          <>
            <div className="card" style={{ 
              marginBottom: '20px', 
              background: 'linear-gradient(135deg, #2481cc 0%, #1a6ba8 100%)', 
              color: 'white',
              boxShadow: '0 4px 12px rgba(36, 129, 204, 0.3)',
              border: 'none'
            }}>
              <div style={{ padding: '24px' }}>
                <div style={{ fontSize: '24px', fontWeight: '700', color: 'white', marginBottom: '8px' }}>
                  {info.title || 'Реферальная программа на дни'}
                </div>
                <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.9)', lineHeight: '1.5' }}>
                  {info.description || 'Приглашайте друзей и получайте бесплатные дни подписки!'}
                </div>
              </div>
            </div>
            
            <div className="card" style={{ 
              marginBottom: '12px', 
              background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', 
              border: '1px solid #fbbf24',
              borderRadius: '12px'
            }}>
              <div style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ fontSize: '40px' }}>🎁</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '12px', color: '#92400e', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600' }}>
                    Бонус приглашенному
                  </div>
                  <div style={{ fontSize: '20px', fontWeight: '700', color: '#78350f' }}>
                    {info.invitee_bonus}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="card" style={{ 
              marginBottom: '20px', 
              background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)', 
              border: '1px solid #60a5fa',
              borderRadius: '12px'
            }}>
              <div style={{ padding: '20px', display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ fontSize: '40px' }}>🎁</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '12px', color: '#1e40af', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600' }}>
                    Ваш бонус
                  </div>
                  <div style={{ fontSize: '20px', fontWeight: '700', color: '#1e3a8a' }}>
                    {info.referrer_bonus}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="card" style={{ marginBottom: '20px', border: '1px solid var(--glass-border)', borderRadius: '12px' }}>
              <div style={{ padding: '20px' }}>
                <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px', fontWeight: '700', color: 'var(--text-primary)' }}>
                  📋 Как это работает:
                </h3>
                <ul style={{ margin: 0, paddingLeft: '24px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                  {info.how_it_works?.map((step, idx) => (
                    <li key={idx} style={{ marginBottom: '12px', paddingLeft: '4px' }}>{step}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="card" style={{ 
              marginBottom: '20px', 
              background: 'linear-gradient(135deg, #2481cc 0%, #1a6ba8 100%)', 
              color: 'white',
              boxShadow: '0 4px 12px rgba(36, 129, 204, 0.3)',
              border: 'none'
            }}>
              <div style={{ padding: '24px' }}>
                <div style={{ fontSize: '24px', fontWeight: '700', color: 'white', marginBottom: '8px' }}>
                  {info.title || 'Реферальная программа с процентами'}
                </div>
                <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.9)', lineHeight: '1.5' }}>
                  {info.description || 'Приглашайте друзей и получайте процент с их покупок на свой баланс!'}
                </div>
              </div>
            </div>
            
            <div className="card" style={{ 
              marginBottom: '20px', 
              background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', 
              color: 'white',
              boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
              border: 'none'
            }}>
              <div style={{ padding: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <div>
                    <div style={{ fontSize: '14px', color: 'rgba(255,255,255,0.8)', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      Ваш процент комиссии
                    </div>
                    <div style={{ fontSize: '48px', fontWeight: '700', color: 'white', lineHeight: '1' }}>
                      {info.your_percent}
                    </div>
                  </div>
                  <div style={{ fontSize: '64px', opacity: '0.2' }}>💰</div>
                </div>
                <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)', marginTop: '12px' }}>
                  С каждой покупки и пополнения ваших рефералов
                </div>
              </div>
            </div>
            
            <div className="card" style={{ marginBottom: '20px', border: '1px solid var(--glass-border)', borderRadius: '12px' }}>
              <div style={{ padding: '20px' }}>
                <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px', fontWeight: '700', color: 'var(--text-primary)' }}>
                  📋 Как это работает:
                </h3>
                <ul style={{ margin: 0, paddingLeft: '24px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                  {info.how_it_works?.map((step, idx) => (
                    <li key={idx} style={{ marginBottom: '12px', paddingLeft: '4px' }}>{step}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* Статистика */}
        <div className="card" style={{ 
          marginBottom: '20px', 
          background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', 
          border: '1px solid #bae6fd',
          borderRadius: '12px'
        }}>
          <div style={{ padding: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: '14px', color: '#0369a1', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: '600' }}>
                👥 Приглашено рефералов
              </div>
              <div style={{ fontSize: '36px', fontWeight: '700', color: '#0284c7' }}>
                {referralData.referrals_count || 0}
              </div>
            </div>
            <div style={{ fontSize: '56px', opacity: '0.3' }}>👥</div>
          </div>
        </div>

        {/* Ссылки */}
        {referralData.referral_link_direct && (
          <div className="card" style={{ marginBottom: '20px', border: '1px solid var(--glass-border)', borderRadius: '12px' }}>
            <div style={{ padding: '20px' }}>
              <h3 style={{ marginTop: 0, marginBottom: '12px', fontSize: '16px', fontWeight: '600', color: 'var(--text-primary)' }}>
                🔗 Ссылка для приглашений (сайт)
              </h3>
              <div className="input-with-button" style={{ marginBottom: '8px' }}>
                <input 
                  type="text" 
                  value={referralData.referral_link_direct} 
                  readOnly 
                  style={{ background: 'var(--surface-muted)', color: 'var(--text-primary)' }}
                />
                <button className="btn-copy" onClick={() => handleCopy(referralData.referral_link_direct, 'direct')} title="Копировать">
                  {isCopied.direct ? <LuCheck /> : <LuCopy />}
                </button>
              </div>
              <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>Для регистрации через сайт</div>
            </div>
          </div>
        )}

        <div className="card" style={{ marginBottom: '20px', border: '1px solid var(--glass-border)', borderRadius: '12px' }}>
          <div style={{ padding: '20px' }}>
            <h3 style={{ marginTop: 0, marginBottom: '12px', fontSize: '16px', fontWeight: '600', color: 'var(--text-primary)' }}>
              🤖 Ссылка для приглашений (бот)
            </h3>
            <div className="input-with-button" style={{ marginBottom: '12px' }}>
              <input 
                type="text" 
                value={referralData.referral_link_telegram || ''} 
                readOnly 
                style={{ background: 'var(--surface-muted)', color: 'var(--text-primary)' }}
              />
              <button className="btn-copy" onClick={() => handleCopy(referralData.referral_link_telegram, 'telegram')} title="Копировать">
                {isCopied.telegram ? <LuCheck /> : <LuCopy />}
              </button>
            </div>
            <button 
              className="btn btn-primary" 
              onClick={handleShareTelegram}
              style={{ 
                marginTop: '8px', 
                width: '100%',
                background: 'linear-gradient(135deg, #2481cc 0%, #1a6ba8 100%)',
                border: 'none',
                boxShadow: '0 4px 12px rgba(36, 129, 204, 0.3)'
              }}
            >
              📤 Пригласить через бота
            </button>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '8px' }}>Для регистрации через Telegram бота</div>
          </div>
        </div>

        <div style={{ 
          marginTop: '20px', 
          padding: '20px', 
          background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)', 
          borderRadius: '12px',
          borderLeft: '4px solid #f59e0b'
        }}>
          <div style={{ fontSize: '14px', color: '#92400e', lineHeight: '1.6' }}>
            💡 <strong>Совет:</strong> Отправьте ссылку тем, кого хотите пригласить. При регистрации по вашей ссылке вы оба получите бонусы!
          </div>
        </div>
      </section>
    </main>
  );
}